import { z } from "zod";

/**
 * Gender enum options for user profile and matching.
 */
export const GenderEnumSchema = z.enum(["female", "male", "nonbinary"]);

export type Gender = z.infer<typeof GenderEnumSchema>;

/** Runtime set derived from the schema — single source of truth with GenderEnumSchema. */
export const GENDER_VALUES = GenderEnumSchema.options;

export function isGender(value: unknown): value is Gender {
  return typeof value === "string" && (GENDER_VALUES as readonly string[]).includes(value);
}
